import { RegionShared } from "@1games-ru/region-shared";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response.ts";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response.ts";
import RpcMpProvider from "@/core/rpc-mp-provider/rpc-mp-provider.ts";

export default class AuthMpProvider {
  public static async signUp(data: {
    email: string;
    password: string;
    promoCode: string;
  }): Promise<RpcMpProviderFailedResponse | RpcMpProviderSuccessResponse<unknown>> {
    return RpcMpProvider.getInstance().callServer<
      { email: string; password: string; promoCode: string },
      unknown
    >(RegionShared.Backend.Events.Auth.StartRegister, data);
  }

  public static async checkEmail(
    email: string,
  ): Promise<
    RpcMpProviderFailedResponse | RpcMpProviderSuccessResponse<{ isEmailExist: boolean }>
  > {
    return RpcMpProvider.getInstance().callServer<{ email: string }, { isEmailExist: boolean }>(
      RegionShared.Backend.Events.Auth.EmailValidate,
      { email },
    );
  }

  public static async goToAccount() {
    return RpcMpProvider.getInstance().callClient(
      RegionShared.Client.Events.Account.MainMenuShow,
      {},
    );
  }

  public static async goToSignIn() {
    return RpcMpProvider.getInstance().callClient(
      RegionShared.Client.Events.Auth.AuthSignInShow,
      {},
    );
  }

  public static async goToSignIn2FA() {
    return RpcMpProvider.getInstance().callClient(
      RegionShared.Client.Events.Auth.AuthSignIn2FAShow,
      {},
    );
  }

  public static async goToCreatePin() {
    return RpcMpProvider.getInstance().callClient(
      RegionShared.Client.Events.Auth.AuthCreatePinShow,
      {},
    );
  }
}
